const axios = require("axios");

const caminhoTiposIdentificadores = `${window.location.protocol}//${window.location.host}/tipos_identificadores.json`;
const opcaoPadrao = {
    text: "SELECIONE",
    value: 0,
    selected: true,
    disabled: true,
    hidden: true,
};

/**
 * Carrega os tipos de identificadores do arquivo JSON.
 * @returns {Promise<Array<{text: string, value: number, disabled: boolean, hidden: boolean}>>}
 */
const carregaTiposIdentificadores = async () => {
    return new Promise((resolve, reject) => {
        axios.get(caminhoTiposIdentificadores).then(({ data }) => {
            const tiposIdentificadores = data.map((item) => {
                return {
                    text: item.DESCRICAO,
                    value: item.ID_TIPO_IDENTIFICADOR,
                    disabled: false,
                    hidden: false,
                }
            });
            resolve([opcaoPadrao, ...tiposIdentificadores]);
        }).catch((err) => {
            reject(err);
        });
    });
}

module.exports = carregaTiposIdentificadores;